module.exports = __webpack_public_path__ + "fonts/Merriweather-400-cyrillic-ext12.4adbd98.woff2";